import React from 'react';
import { datasetUrl } from '@/constants/urls';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';

const DatasetNotificationHistoryAction = ({ code, disabled }) => (
  <RibbonMenu
    url={`${datasetUrl({ code }, '#')}/notifications`}
    name="notifications"
    icon="bell outline"
    message="actions.notifications"
    className="aridhia-dataset-notification-history-action"
    disabled={disabled}
  />
);

export default DatasetNotificationHistoryAction;
